import { render, staticRenderFns } from "./ResourceIdTableCell.vue?vue&type=template&id=2730e4f2&scoped=true"
import script from "./ResourceIdTableCell.vue?vue&type=script&lang=js"
export * from "./ResourceIdTableCell.vue?vue&type=script&lang=js"
import style0 from "./ResourceIdTableCell.vue?vue&type=style&index=0&id=2730e4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730e4f2",
  null
  
)

export default component.exports